// extracted by mini-css-extract-plugin
export default {"page":"sFOR6","logs":"Ex0zx"};